/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdistatusProfileDisplay.ts       *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edistatus-profile-display";

export class AutogenModelEdistatusProfileDisplay<RowType extends ModelRow> extends Endpoint<RowType, RowEdistatusProfileDisplayFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdistatusProfileDisplay extends ModelRow<RowEdistatusProfileDisplayFields> {
	constructor(values?: Partial<RowEdistatusProfileDisplayFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdistatusProfileDisplayFields {
	ack_xmit_method: string;
	agent_payee_id: string;
	allow_update: string;
	alt_partner_id: string;
	audit_cutoff_days: number;
	audit_interval: number;
	batch_method: string;
	carrier_id: string;
	company_id: string;
	consolidates_stops: string;
	create_method: string;
	create_svrfail: string;
	days_to_retain: number;
	delay_req: string;
	dest_stop_no: string;
	direction: string;
	edi_comm_id: number;
	"edi_template.ack_required": string;
	"edi_template.app_receiver_code": string;
	"edi_template.app_receiver_id": string;
	"edi_template.app_sender_code": string;
	"edi_template.app_sender_id": string;
	"edi_template.authen_info": string;
	"edi_template.authen_info_qual": string;
	"edi_template.company_id": string;
	"edi_template.ctl_version": string;
	"edi_template.ctl_version_qual": string;
	"edi_template.descr": string;
	"edi_template.direction": string;
	"edi_template.ele_separator": number;
	"edi_template.end_of_line_1": number;
	"edi_template.end_of_line_2": number;
	"edi_template.filepath": string;
	"edi_template.format_type": string;
	"edi_template.functional_id": string;
	"edi_template.id": number;
	"edi_template.industry": string;
	"edi_template.is_multi_partner": string;
	"edi_template.name": string;
	"edi_template.parse_batch_number": string;
	"edi_template.parse_create_date": string;
	"edi_template.parse_create_datef": string;
	"edi_template.parse_fg_segment": string;
	"edi_template.parse_tran_ctrl_no": string;
	"edi_template.parse_tran_segment": string;
	"edi_template.receiver_id": string;
	"edi_template.receiver_qual": string;
	"edi_template.secur_info": string;
	"edi_template.secur_info_qual": string;
	"edi_template.sender_id": string;
	"edi_template.sender_qual": string;
	"edi_template.spec_footer_text": string;
	"edi_template.spec_header_text": string;
	"edi_template.spec_title": string;
	"edi_template.standard": string;
	"edi_template.subele_separator": number;
	"edi_template.tag_format_text": string;
	"edi_template.test_indicator": string;
	"edi_template.transaction_set": string;
	"edi_template.transaction_type": string;
	"edi_template.translation_method": string;
	"edi_template.update_date": Date;
	"edi_template.version": string;
	enf_batch_cont: string;
	enf_batch_cont_997: string;
	fa_threshold: number;
	filename: string;
	func_ack_filename: string;
	func_ack_st02_frmt: string;
	func_ack_tid: number;
	func_altpartner_id: string;
	func_comm_id: number;
	func_next_batch: number;
	func_partner_id: string;
	func_use_m_batch: string;
	func_version: string;
	hold_for_preverr: string;
	hold_type: string;
	id: string;
	ignore_map_errors: string;
	img_def_loc_dir: string;
	img_dir_local: string;
	img_document_types: string;
	img_filetype: string;
	img_required: string;
	individual_batch: string;
	intercompany: string;
	interval_hours: number;
	interval_minutes: number;
	next_batch: number;
	notes: string;
	orig_stop_no: string;
	partner_id: string;
	partner_name: string;
	process_priority: number;
	remove_file: string;
	remove_func_ack: string;
	send_func_ack: string;
	send_to_company: string;
	skip_manual_orders: string;
	special_processing: string;
	st02_format: string;
	status_on_delivery: string;
	status_on_pickup: string;
	template_id: number;
	transaction_set: string;
	transmit_method: string;
	update_stop: string;
	use_master_batch: string;
	use_show_as: string;
	version: string;
}

